import get from 'lodash/get';
// oxlint-disable-next-line typescript/no-explicit-any
export const sortByDateString = (dataToSort, propertyToSortBy, order) => {
    const sortedData = dataToSort.sort((a, b) => {
        const formatedAValue = a[propertyToSortBy]?.replace(' +', '+');
        const formatedBValue = b[propertyToSortBy]?.replace(' +', '+');
        if (order === 'asc') {
            // oxlint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore -- was here before, don't want to change
            return new Date(formatedAValue) - new Date(formatedBValue);
        }
        if (order === 'desc') {
            // oxlint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore -- was here before, don't want to change
            return new Date(formatedBValue) - new Date(formatedAValue);
        }
        return 0;
    });
    return sortedData;
};
const parseDate = (date) => {
    if (!date)
        return;
    if (date instanceof Date)
        return date;
    return new Date(date);
};
// oxlint-disable-next-line typescript/no-explicit-any
export const sortByDate = (dataToSort, propertyToSortBy, order) => {
    const sortedData = dataToSort.sort((a, b) => {
        const formatedAValue = parseDate(a[propertyToSortBy]);
        const formatedBValue = parseDate(b[propertyToSortBy]);
        if (order === 'asc') {
            // oxlint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore -- was here before, don't want to change
            return formatedAValue - formatedBValue;
        }
        if (order === 'desc') {
            // oxlint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore -- was here before, don't want to change
            return formatedBValue - formatedAValue;
        }
        return 0;
    });
    return sortedData;
};
// oxlint-disable-next-line typescript/no-explicit-any
export const sortByNumber = (dataToSort, propertyToSortBy, order) => {
    const sortedData = dataToSort.sort((a, b) => {
        const aProp = a[propertyToSortBy];
        const bProp = b[propertyToSortBy];
        const parsedValueA = typeof aProp === 'string' ? Number.parseInt(aProp, 10) : aProp;
        const parsedValueB = typeof bProp === 'string' ? Number.parseInt(bProp, 10) : bProp;
        if (order === 'asc')
            return parsedValueA - parsedValueB;
        if (order === 'desc')
            return parsedValueB - parsedValueA;
        return 0;
    });
    return sortedData;
};
export const sortByBoolean = (dataToSort, propertyToSortBy, order) => {
    const sortedData = dataToSort.sort((a, b) => {
        const aProp = a[propertyToSortBy];
        const bProp = b[propertyToSortBy];
        if (aProp === bProp)
            return 0;
        if (aProp)
            return order === 'asc' ? -1 : 1;
        return order === 'asc' ? 1 : -1;
    });
    return sortedData;
};
// oxlint-disable-next-line typescript/no-explicit-any
export const sortByString = (dataToSort, propertyToSortBy, order) => {
    const fn = typeof propertyToSortBy === 'function'
        ? propertyToSortBy
        : (a) => get(a, propertyToSortBy)?.toUpperCase() || '';
    const sortedData = dataToSort.sort((a, b) => {
        const stringA = fn(a);
        const stringB = fn(b);
        if (order === 'asc')
            return stringA.localeCompare(stringB);
        if (order === 'desc')
            return stringB.localeCompare(stringA);
        return 0;
    });
    return sortedData;
};
//# sourceMappingURL=sort.js.map